<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/activity-log">Log Aktivitas User</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Daftar User</li>
      </ol>
    </nav>

    <DxPopup
      :visible="popupLoginVisible"
      title="Masukkan password superadmin"
      :drag-enabled="false"
      :hide-on-outside-click="false"
      width="300"
      :height="200"
    >
      <DxValidationGroup ref="refValidationLogin">
        <div style="display: flex; gap: 8px; align-items: flex-end">
          <div style="flex: 1">
            <DxTextBox
              ref="passwordInput"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              width="100%"
              label="Password"
              placeholder="Password"
              v-model="formDataLogin.password"
              :mode="showPassword ? 'text' : 'password'"
              @key-up="onPasswordKeyUp"
            >
              <DxValidator>
                <DxRequiredRule />
              </DxValidator>
            </DxTextBox>
          </div>
          <DxButton
            :icon="showPassword ? 'eyeopen' : 'close'"
            @click="togglePasswordVisibility"
            styling-mode="text"
            :title="showPassword ? 'Hide password' : 'Show password'"
            style="margin-bottom: 4px"
          />
        </div>
      </DxValidationGroup>

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="before"
        :options="cancelButtonOptionsLogin"
      />

      <DxToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        :options="confirmButtonOptionsLogin"
      />
    </DxPopup>

    <div class="content-block">
      <h5>Daftar User</h5>
    </div>
    <LogPopupTemplate ref="logPopup" />

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          :focused-row-enabled="true"
          ref="dataGrid"
          :data-source="userListStore.dataSourceUserList"
          :allow-column-reordering="true"
          :show-borders="true"
          :show-column-lines="false"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @exporting="onExporting"
          @editing-start="onEditingStart"
          @init-new-row="initNewRow($event)"
          @row-removing="onRowRemoving"
          @row-inserting="onInserting"
          @row-updating="(e) => onUpdating(e)"
          @saved="onSaved"
          @saving="onSaving"
          @editor-preparing="onEditorPreparing"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
        >
          <!-- :filter-value="filterValue"
        :filter-sync-enabled="true" -->
          <!-- @selection-changed="onSelectionChanged" -->
          <DxHeaderFilter :visible="true" />

          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />
          <DxExport :enabled="true" />
          <DxEditing
            :allow-updating="allowUpdate(can('superadmin'), can('superadmin'))"
            :allow-deleting="false"
            :allow-adding="can('superadmin')"
            :mode="dxEditingMode"
            v-bind="commonFunction.editingConfig(dxEditingMode, 'user')"
          />
          <!--  -->

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="groupPanel" />
            <DxItem name="addRowButton" show-text="always" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
            <DxItem name="searchPanel" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('dataGrid')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>

          <!-- cell-template="diff-cell-template" -->

          <DxColumn
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />

          <dx-column
            data-field="id"
            caption="id"
            data-type="number"
            :visible="false"
          />

          <dx-column
            data-field="simpeg_pegawais_nama"
            caption="Nama Pegawai"
            :visible="true"
            :allowHeaderFiltering="true"
            :allow-sorting="false"
            :header-filter="{
              dataSource: commonStore.getPegawaiSource(pegawaiSource).value,
            }"
            edit-cell-template="editPegawaiTemplate"
          >
            <!-- <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="pegawaiSource"
            /> -->
            <DxRequiredRuleDataGrid />
          </dx-column>

          <template #editPegawaiTemplate="{ data: cellInfo }">
            <DxSelectBox
              ref="selectDxediting"
              :dataSource="pegawaiSourceSelectable"
              valueExpr="id"
              displayExpr="nama"
              width="100%"
              :styling-mode="stylingMode"
              :label-mode="labelMode"
              :searchEnabled="true"
              :value="selectedPegawaiId"
              @valueChanged="handlePegawaiChange($event, cellInfo)"
            />
          </template>

          <DxColumn
            data-type="string"
            data-field="users_name"
            caption="Nama User"
            :allowHeaderFiltering="false"
            :allow-editing="can('superadmin')"
          >
            <DxRequiredRule />
          </DxColumn>

          <DxColumn
            :allow-hiding="false"
            data-field="email"
            caption="Email"
            :allowHeaderFiltering="false"
            :allow-editing="can('superadmin')"
          >
            <DxRequiredRule />
            <DxEmailRule />
          </DxColumn>

          <DxColumn
            data-field="role_id"
            caption="Role"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.getRoleSource('crud').value,
            }"
          >
            <DxLookup
              display-expr="name"
              value-expr="id"
              :data-source="commonStore.roleStore"
            />
            <DxRequiredRule />
          </DxColumn>
          <DxColumn
            data-field="status"
            caption="Status"
            :allowHeaderFiltering="true"
            :header-filter="{
              dataSource: commonStore.statusUserSource,
            }"
          >
            <DxLookup
              display-expr="val"
              value-expr="val"
              :data-source="commonStore.statusUserStore"
            />
          </DxColumn>

          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />
          <DxColumn type="buttons" :width="110">
            <DxButtonDataGrid name="edit" />

            <DxButtonDataGrid
              hint="Reset Password"
              icon="refresh"
              :visible="true"
              @click="resetPassword($event)"
            />
          </DxColumn>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<script>
import { DxSelectBox } from "devextreme-vue/select-box";
import DxValidationGroup from "devextreme-vue/validation-group";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import LogPopupTemplate from "./LogPopupTemplate.vue";
import auth from "../auth";
import * as commonFunction from "@/utils/common-function.js";
import { useUserListStore } from "@/stores/views/user-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";
import DxButton from "devextreme-vue/button";
import notify from "devextreme/ui/notify";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
  DxRequiredRule,
  DxEmailRule,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";
import { usePegawaiListStore } from "@/stores/views/pegawai-list-store";
/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
    DxRequiredRule,
    DxEmailRule,
    DxButtonDataGrid,
    DxPopup,
    DxToolbarItem,
    DxValidationGroup,
    DxSelectBox,
  },
  setup() {
    const userListStore = useUserListStore();
    userListStore.dataSourceUserList.filter(null);

    const pegawaiListStore = usePegawaiListStore();
    pegawaiListStore.dataSourcePegawaiList.filter(null);
    const commonStore = useCommonStore();

    return {
      userListStore,
      pegawaiListStore,
      commonStore,
      commonFunction,
    };
  },
  data() {
    const vm = this;
    return {
      selectedPegawaiId: null,
      popupLoginVisible: false,
      logPopupRef: null,
      dxEditingMode: "popup", //row

      stylingMode: "filled",
      //outlined, filled, underlined
      labelMode: "floating",
      formDataLogin: {
        password: "",
      },
      pegawaiSource: null,
      pegawaiSourceSelectable: null,
      showPassword: false,

      numberingPageSize: 100,

      confirmButtonOptionsLogin: {
        text: "Konfirmasi",
        // useSubmitBehavior: "true",
        onClick: () => {
          this.onSubmitLogin();
        },
      },
      emailReset: null,

      cancelButtonOptionsLogin: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupLoginVisible = false;
          this.formDataLogin = {
            password: "",
          };
        },
      },
    };
  },

  async created() {
    await this.commonStore.preloadStores();
    await this.getPegawaiSource();
  },

  async mounted() {
    console.log("rolestore", this.commonStore.roleStore);
  },

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  watch: {
    popupLoginVisible(newVal) {
      if (newVal) {
        // Focus on password input when popup becomes visible
        this.$nextTick(() => {
          if (this.$refs.passwordInput && this.$refs.passwordInput.instance) {
            this.$refs.passwordInput.instance.focus();
          }
        });
      }
    },
  },

  methods: {
    async onSaved(e) {
      console.log("onSaved e", e);
      this.refreshDatagrid("dataGrid");
    },
    async handlePegawaiChange(e, cellInfo) {
      this.selectedPegawaiId = e.value;
      cellInfo.setValue(e.value);
      const selectedPegawai = this.pegawaiSource.find(
        (pegawai) => pegawai.id === this.selectedPegawaiId,
      );

      cellInfo.component.cellValue(
        cellInfo.rowIndex,
        "users_name",
        selectedPegawai ? selectedPegawai.nama : null,
      );

      cellInfo.component.cellValue(
        cellInfo.rowIndex,
        "email",
        selectedPegawai ? selectedPegawai.email : null,
      );
    },
    async getPegawaiSource() {
      let tempA = await this.pegawaiListStore.dataSourcePegawaiListCoba(null, [
        {
          selector: "simpeg_pegawais.nama",
          desc: false,
        },
      ]);
      tempA.data.unshift({ id: null, display_expr: null });

      this.pegawaiSource = tempA.data;
      console.log("pegawaiSource", this.pegawaiSource);
    },
    onPasswordKeyUp(e) {
      // Check if Enter key was pressed (keyCode 13 or key === 'Enter')
      if (e.event.key === "Enter" || e.event.keyCode === 13) {
        this.onSubmitLogin();
      }
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    async onSubmitLogin() {
      try {
        const result = this.$refs.refValidationLogin.instance.validate();

        if (!result.isValid) return;

        //sudah valid, lakukan cek login
        const login = await auth.confirmPassword(
          auth.getUser().email,
          this.formDataLogin.password,
        );

        if (!login.isOk) {
          notify("Password Salah", "error", 2000);
          this.formDataLogin.password = "";
        } else {
          this.popupLoginVisible = false;
          this.formDataLogin.password = "";

          const reset = await auth.resetPassword(this.emailReset);
          console.log("reset", reset);
          if (reset.isOk) {
            this.refreshDatagrid("dataGrid");
          }
          notify(reset.message, reset.notify_type);
        }
      } catch (err) {
        console.error("Error during password confirmation or reset:", err);
        notify("An error occurred. Please try again.", "error", 4000);
      }
    },

    resetPassword(e) {
      const user = e.row && e.row.data;
      if (!user) {
        notify("No user data found for this row", "error", 4000);
        return;
      }
      if (user.role_id === 1) {
        notify("Reset password is disabled for this role", "error", 4000);
        return;
      }
      console.log("Reset password for user:", user);

      confirm(
        `Are you sure you want to reset the password for ${user.users_name}?`,
        "Confirm Password Reset",
      ).then((result) => {
        if (result) {
          // Call your API to reset the password here
          // For example:
          // axios.post(`/api/reset-password/${user.id}`).then(() => {
          //   notify("Password has been reset successfully", "success", 4000);
          // }).catch(() => {
          //   notify("Failed to reset password", "error", 4000);
          // });
          this.emailReset = user.users_email;
          this.popupLoginVisible = true;
        }
      });
    },
    onSaving(e) {
      this.selectedPegawaiId = null;
      console.log("onSaving e", e);
      if (e.changes && e.changes.length > 0) {
        console.log("onSaving changes", e.changes);
        e.changes.forEach((change) => {
          console.log("change type:", change.type, "data:", change.data);
          if (change.data && change.data.simpeg_pegawais_nama !== undefined) {
            change.data.pegawai_id = change.data.simpeg_pegawais_nama;
            delete change.data.simpeg_pegawais_nama;
          }
        });
      }
    },
    can,
    showData(data) {
      console.log("showData", data);
      // return data.simpeg_pegawais_nama;
    },

    allowUpdate(a, b) {
      if (a || b) return true;
      else return false;
    },
    initNewRow(e) {
      this.setPegawaiSourceSelectable({ pegawai_id: null }); // reset selectable pegawai list for new row
      e.data.created_by_user_id = auth.getUser().id;
      // new users start in pending state and cannot modify the status
      e.data.status = "PENDING";
      this.selectedPegawaiId = null;
    },
    onUpdating(e) {
      // Prevent manually setting status to PENDING
      if (e.newData.status === "PENDING") {
        e.cancel = true;
        notify("CANNOT MANUALLY SET STATUS TO PENDING", "error", 4000);
        return;
      }

      e.newData.updated_by_user_id = auth.getUser().id;
      console.log("onUpdating newData", e.newData);
      console.log("onUpdating oldData", e.oldData);
    },
    // disable status editor only for new rows (set to PENDING and locked)
    onEditorPreparing(e) {
      if (e.parentType === "dataRow" && e.dataField === "status") {
        console.log("onEditorPreparing status 1", e);
        if (e.row && e.row.isNewRow) {
          console.log("onEditorPreparing status 2", e);
          e.editorOptions.disabled = true;
        }
      }
    },

    setPegawaiSourceSelectable(row) {
      // allow selection of pegawai entries that are unassigned (pegawai_id null) or match the current row
      this.pegawaiSourceSelectable = this.pegawaiSource.filter(
        (p) => p.users_id === null || p.id === row.pegawai_id,
      );

      // ensure there is exactly one null entry at the top of the list
      if (!this.pegawaiSourceSelectable.some((p) => p.id === null)) {
        this.pegawaiSourceSelectable.unshift({
          id: null,
          display_expr: null,
        });
      }
    },

    onEditingStart(e) {
      try {
        const row = e && e.data;
        console.log("onEditingStart row", row);
        if (row && row.role_id === 1) {
          e.cancel = true;
          notify("Editing is disabled for this role", "error", 4000);
        }
        // if (row && row.status === "PENDING") {
        //   e.cancel = true;
        //   notify("Editing is disabled for pending users", "error", 4000);
        // }
        // allow selection of pegawai entries that are unassigned (pegawai_id null) or match the current row
        // this.pegawaiSourceSelectable = this.pegawaiSource.filter(
        //   (p) => p.users_id === null || p.id === row.pegawai_id,
        // );

        // // ensure there is exactly one null entry at the top of the list
        // if (!this.pegawaiSourceSelectable.some((p) => p.id === null)) {
        //   this.pegawaiSourceSelectable.unshift({
        //     id: null,
        //     display_expr: null,
        //   });
        // }
        this.setPegawaiSourceSelectable(row);
        console.log("pegawaiSourceSelectable", this.pegawaiSourceSelectable);

        this.selectedPegawaiId = e.data.pegawai_id;
      } catch (err) {
        console.error("onEditingStart error", err);
      }
    },

    onRowRemoving(e) {
      try {
        const row = e && e.data;
        if (row && row.role_id === 1) {
          e.cancel = true;
          notify("Deleting is disabled for this role", "error", 4000);
        }
        if (row && row.status === "PENDING") {
          e.cancel = true;
          notify("Deleting is disabled for pending users", "error", 4000);
        }
      } catch (err) {
        console.error("onRowRemoving error", err);
      }
    },

    onItemClick(e, data) {
      console.log("onItemClick e", e);
      console.log("onItemClick data", data);
      let pegawaiId = data.pegawai_id;

      if (e.itemData === "Absensi") {
        const url = this.$router.resolve({
          name: "absen-list-custom",
          query: { filter: ["absen_bulans_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Riwayat Gaji") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: { filter: ["gajis_pegawai_id", "=", pegawaiId] },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData === "Detail Pegawai") {
        const url = this.$router.resolve({
          name: "pegawai-detail-custom",
          query: { id: pegawaiId },
        }).href;
        window.open(url, "_blank");
      }
    },

    can,

    refreshDatagrid(gridRef) {
      // this.pengajuanListStore.dataSourcePengajuanList.filter(null);
      // this.$refs[gridRef].instance.clearFilter();
      this.$refs[gridRef].instance.getDataSource().reload();
      this.getPegawaiSource();
    },

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Daftar User");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar User.xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
